<template>
    <az-container>
        <az-form>
            <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                          :pagination.sync="paginacaoInterna" :loading="false"
                          :no-data-text="textoVazio" :style="cssVar" hide-actions
                          class="az-table-list listagem-tabela">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td @click="$emit('acessar', props.item.id)">
                            {{ props.item.dataHoraEncerramento | az-date('DD/MM/YYYY') }}<br>
                            <span v-if="props.item.dataHoraEncerramento">
                                {{ props.item.dataHoraEncerramento | az-date('HH:mm') }}
                            </span>
                        </td>
                        <td @click="$emit('acessar', props.item.id)">
                            {{ props.item.processo }}
                            <br>
                            <span v-if="props.item.quantidadeRepeticoes">
                               <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                            </span>
                        </td>
                        <td @click="$emit('acessar', props.item.id)">
                            <expansao-texto :tamanho="150" :texto="props.item.objeto ? props.item.objeto : ''"></expansao-texto>
                        </td>
                        <td @click="$emit('acessar', props.item.id)">
                            {{ props.item.tipo | cdEnum(tiposCompraDireta) }}
                        </td>
                        <td @click="$emit('acessar', props.item.id)">
                            {{ props.item.orgao }}
                        </td>
                        <td v-if="identificacaoMenu === 'menuEmAndamento'" @click="$emit('acessar', props.item.id)">
                            {{ props.item.situacao | azEnum(situacoesCompraDireta) }}
                        </td>
                        <td class="table-actions">
                            <v-tooltip top v-if="devePermitirRepeticaoSGC(props.item)">
                                <a slot="activator">
                                    <i class="fas fa-undo pr-2" id="repetir" aria-hidden="true"
                                       @click.stop.prevent="$emit('repetirCompra', props.item)"/>
                                </a>
                                Repetir Compra
                            </v-tooltip>
                            <v-tooltip top
                                       v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                                       v-if="props.item.situacao === 'EM_ELABORACAO'">
                                <a slot="activator">
                                    <i class="fas fa-trash-alt pr-2" id="excluir" @click.stop.prevent="$emit('excluir', props.item.id)" aria-hidden="true"/>
                                </a>
                                Excluir Compra
                            </v-tooltip>
                            <v-tooltip top v-if="identificacaoMenu !== 'menuEncerradas'">
                                <a slot="activator">
                                    <i class="fas fa-sign-in-alt pr-2" aria-hidden="true" @click="$emit('acessar', props.item.id)"/>
                                    <span class="acao-mobile">Acessar</span>
                                </a>
                                Acessar
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.sequencialCompraPublica">
                                <a @click="$emit('acessarPncp', props.item)" slot="activator">
                                    <i class="fas fa-external-link-alt" aria-hidden="true"/>
                                    <span class="acao-mobile">Acessar no PNCP</span>
                                </a>
                                Acessar no PNCP
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="az-pagination">
                <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
import {mapState} from 'vuex'
import {tiposCompraDireta, situacoesCompraDireta} from '@/core/constants'

export default {
    name: 'ListagemCompraDiretaSituacaoUnica',
    props: ['itens', 'paginacao', 'paginas', 'textoVazio', 'totalItens', 'identificacaoMenu'],
    data() {
        return {
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
            tiposCompraDireta,
            situacoesCompraDireta
        }
    },
    computed: {
        ...mapState(['loki', 'parametros']),
        cssVar() {
            const labelOrgao = this.$t('main.commons_listagem_situacao.text')
            return {
                '--label-orgao': `"${labelOrgao}:"`
            }
        },
        colunas() {
            const colunasBase = [
                {
                    value: 'dataHoraEncerramento',
                    sortable: true,
                    text: 'Encerramento',
                    width: '40px',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    align: 'left',
                    sortable: true,
                    text: 'Nº Processo',
                    width: '100px',
                    value: 'processo',
                    class: 'primary--text'
                },
                {
                    value: 'objeto',
                    sortable: true,
                    width: '250px',
                    text: 'Objeto',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    sortable: true,
                    align: 'left',
                    width: '80px',
                    text: 'Tipo',
                    value: 'tipo',
                    class: 'primary--text'
                },
                {
                    value: 'orgao',
                    align: 'left',
                    sortable: false,
                    width: '30px',
                    text: this.$t('main.commons_listagem_situacao.text'),
                    class: 'primary--text'
                }
            ]

            if (this.identificacaoMenu === 'menuEmAndamento') {
                colunasBase.push({
                    text: 'Situação',
                    value: 'situacao',
                    sortable: true,
                    align: 'left',
                    width: '60px',
                    class: 'primary--text'
                })
            }

            colunasBase.push({
                text: 'Ações',
                sortable: false,
                width: '30px',
                align: 'center',
                class: 'primary--text'
            })

            return colunasBase
        }
    },
    methods: {
        devePermitirRepeticaoSGC(item) {
            return item.origem === 'SGC' && item.permiteRepetir
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-container
        margin-bottom 60px

    .listagem-tabela
        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .listagem-tabela
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content var(--label-orgao)

            td:nth-of-type(6):before
                content "Situação:"

            td:nth-of-type(7):before
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin-bottom 0
</style>